<template>
    <div id="invoiceToken">
        <div class="text-xl font-semibold">
            Order Token
        </div>
        <div class="my-4">
            <span>Ordered by: </span> <span class="uppercase">{{ orderedBy }}</span>
        </div>
        <div class="mb-6">
            <span>Order Date: </span> <span>{{ orderDate | readableDate }}</span>
        </div>
        <table class="w-full my-2 border border-collapse  table-auto">
            <thead>
                <th class="border px-4 py-2 text-center">
                    S.N.
                </th>
                <th class="border px-4 py-2 text-left">
                    Product Name
                </th>
                <th class="border px-4 py-2 text-left">
                    Price/Unit
                </th>
                <th class="border px-4 py-2 text-left">
                    Quantity
                </th>
                <th class="border px-4 py-2 text-left">
                    Total
                </th>
            </thead>
            <tbody>
                <tr v-for="(transaction, index) in transactions" :key="transaction.id">
                    <td class="border px-4 py-2 text-center">
                        {{ index + 1 }}
                    </td>

                    <td class="border px-4 py-2 text-left">
                        {{ transaction.product.name }}
                    </td>
                    <td class="border px-4 py-2 text-left">
                        <span>{{ config(common.currency) }}</span>
                        {{ transaction.product.price }}
                    </td>
                    <td class="border px-4 py-2 text-left">
                        {{ transaction.qty }}
                    </td>
                    <td class="border px-4 py-2 text-left">
                        <span>{{ config(common.currency) }}</span>
                        {{ (transaction.qty * parseFloat(transaction.product.price)).toFixed(2) }}
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import common from '@/common';

export default {
    name: 'InvoiceToken',

    props: {
        bill: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            common,
        };
    },

    computed: {
        transactions() {
            return this.bill.transactions;
        },

        orderDate() {
            return this.bill.created_at;
        },

        orderedBy() {
            return this.bill.user.name;
        },
    },

    methods: {
        async printToken() {
            await this.$htmlToPaper('invoiceToken');
        },
    },
};
</script>

<style></style>
